import { render, staticRenderFns } from "./MappingSource.vue?vue&type=template&id=2f1f3142"
import script from "./MappingSource.vue?vue&type=script&lang=js"
export * from "./MappingSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports